import { render, staticRenderFns } from "./TeamComparison.vue?vue&type=template&id=b44408ce&"
import script from "./TeamComparison.vue?vue&type=script&lang=js&"
export * from "./TeamComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports